import { v2 } from "@pufflig/prompt-studio-types";
import { PromptbookWebRuntime } from "@pufflig/promptbook-runtime";

export const setupDB = async (runtime: PromptbookWebRuntime, resources: v2.Resource[], schemaName = "main") => {
  for (const resource of resources) {
    if (resource.resourceType === "table") {
      const tableData = await runtime.storage.loadRawFile(resource.resourceId);
      runtime.db.createTableFromFile(resource.resourceId, tableData, schemaName);
    }
  }
};
